











































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component({
  name: 'BaseForm'
})
export default class BaseForm extends Vue {
  @Prop({ default: null })
  private component: any

  private style = this.getStyle()
  private labelStyle = this.getLabelStyle()
  private inputStyle = this.getInputStyle()
  private buttonStyle = this.getButtonStyle()
  private inputs = this.component.action.config

  @Watch('component', { deep: true })
  private watchComponent (): void {
    this.style = this.getStyle()
    this.labelStyle = this.getLabelStyle()
    this.inputStyle = this.getInputStyle()
    this.buttonStyle = this.getButtonStyle()
    this.inputs = this.component.action.config
  }

  private getStyle (): string {
    const ret: Array<string> = []
    this.component.style.forEach((item: any) => {
      if (item.val) {
        if (item.attr === 'background-image') {
          ret.push(item.attr + ':url(' + item.val + ')')
        } else {
          const unit = item.unit || ''
          ret.push(item.attr + ':' + item.val + unit)
        }
      }
    })
    return ret.join(';')
  }

  private getLabelStyle (): string {
    const ret: Array<string> = [
      'width:' + this.component.others.config[0].val + 'px',
      'height:' + this.component.others.config[1].val + 'px',
      'line-height:' + this.component.others.config[1].val + 'px'
    ]
    return ret.join(';')
  }

  private getInputStyle (): string {
    const ret: Array<string> = []
    this.component.others.config.forEach((item: any) => {
      const isInput: number = item.attr.indexOf('form-input_')
      const idx: number = item.attr.indexOf('_')
      if (isInput === 0) {
        const unit: string = item.unit || ''
        item.val && ret.push(item.attr.substring(idx + 1, item.attr.length) + ':' + item.val + unit)
      }
    })
    return ret.join(';')
  }

  private getButtonStyle (): string {
    const ret: Array<string> = []
    this.component.others.config.forEach((item: any) => {
      const isInput: number = item.attr.indexOf('form-btn_')
      const idx: number = item.attr.indexOf('_')
      if (isInput === 0) {
        const unit: string = item.unit || ''
        const attr: string = item.attr.substring(idx + 1, item.attr.length)
        item.val && ret.push(attr + ':' + item.val + unit)
        attr === 'height' && ret.push('line-height:' + (parseInt(item.val) - 2 + unit))
      }
    })
    return ret.join(';')
  }
}
